var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"visible":_vm.isInactive,"heading":_vm.$t('elements.kiosk-mode.heading'),"description":_vm.$tc('elements.kiosk-mode.description', _vm.secondsTilReset),"buttons":[
    {
      caption: this.$t('elements.kiosk-mode.reset'),
      theme: 'neutral',
      eventName: 'reset',
    },
    {
      caption: this.$t('elements.kiosk-mode.resume'),
      theme: 'primary',
      eventName: 'resume',
    } ],"icon":"undo","width":"slim"},on:{"reset":_vm.reset,"resume":_vm.resume}})}
var staticRenderFns = []

export { render, staticRenderFns }